'use client';
import { Details } from './details.js';
import { DetailsContent } from './details-content.js';
import { DetailsSummary } from './details-summary.js';

/**
 * Details component, contains `Details.Summary` and `Details.Content` components.
 *
 * @example
 * <Details>
 *  <Details.Summary>Header</Details.Summary>
 *  <Details.Content>Content</Details.Content>
 * </Details>
 */
const DetailsComponent = Object.assign(Details, {
    Summary: DetailsSummary,
    Content: DetailsContent,
});
DetailsComponent.Summary.displayName = 'Details.Summary';
DetailsComponent.Content.displayName = 'Details.Content';

export { DetailsComponent as Details, DetailsContent, DetailsSummary };
